import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => gamesAPI.getSubsidiaries());

        yield put({
            type: GamesActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: GamesActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(GamesActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
